export const studyEn = {
  common: {
    academy: 'Academy',
    brand: 'Deenly Academy',
    studyRoom: 'Study room',
    collection: 'Collection',
    map: 'Map',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    close: 'Close',
    search: 'Search…',
    all: 'All',
    loading: 'Loading…',
    rename: 'Rename',
    name: 'Name',
    edit: 'Edit',
    write: 'Write',
    fromCollection: 'From the Collection',
    onMap: 'To the map',
    email: 'Email',
    password: 'Password',
    cards: '{n} card | {n} cards',
    pages: '{n} page | {n} pages',
    color: 'Color {name}',
    colorColon: 'Color: {name}',
    colors: { teal: 'teal', gold: 'gold', rose: 'rose', sky: 'sky', violet: 'violet', slate: 'slate', mint: 'mint', lilac: 'lilac', white: 'white' },
  },
  errors: {
    network: 'No connection to the server. Check your internet and try again.',
    tooMany: 'Too many attempts. Wait a minute and try again.',
    generic: 'Something went wrong. Try again.',
  },
  cardTypes: {
    quran: { label: 'Quran', short: 'Ayah' },
    hadith: { label: 'Sunnah', short: 'Hadith' },
    scholar: { label: 'Scholars', short: 'Quote' },
    root: { label: 'Roots', short: 'Root' },
    note: { label: 'Mine', short: 'Note' },
  },
  templates: {
    fiqh: {
      label: 'Fiqh question',
      hint: 'What the ruling on something is: evidence from the Quran and Sunnah, the scholars’ opinions, your conclusion.',
      lanes: { question: 'Question', quran: 'Quran', sunnah: 'Sunnah', opinions: 'Scholars’ opinions', conclusion: 'Conclusion' },
    },
    tafsir: {
      label: 'Tafsir of an ayah',
      hint: 'One ayah or passage: its words, the occasion of revelation, what the mufassirun say, lessons.',
      lanes: { ayah: 'Ayah', words: 'Words and roots', occasion: 'Occasion of revelation', tafsirs: 'Tafsirs', lessons: 'Lessons' },
    },
    hadith: {
      label: 'Hadith study',
      hint: 'One hadith: its text and source, sharh, the rulings that follow from it, lessons.',
      lanes: { text: 'Text and source', sharh: 'Sharh', rulings: 'Rulings from the hadith', lessons: 'Lessons' },
    },
    free: {
      label: 'Free map',
      hint: 'An empty map with no frames, for everything else.',
    },
  },
  taskColumns: { todo: 'To do', doing: 'In progress', done: 'Done' },
  card: {
    page: 'p. {page}',
    noteLine: 'Note: {note}',
  },
  due: {
    late: '{n} d late',
    today: 'today',
    tomorrow: 'tomorrow',
    in: 'in {n} d',
  },
  password: {
    length: 'At least {n} characters',
    letters: 'Letters',
    numbers: 'Numbers',
    match: 'Both passwords match',
    failed: 'Something went wrong. Please try again.',
    offline: 'No connection to the server. Check your internet and try again.',
    tooMany: 'Too many attempts. Wait a minute and try again.',
    meter: 'Password strength',
    show: 'Show password',
    hide: 'Hide password',
    caps: 'Caps Lock is on',
    privacy: 'Privacy',
    strength: ['Too weak', 'Weak', 'Solid', 'Strong', 'Excellent'],
  },
  auth: {
    panelBadge: 'Deenly panel',
    backToSite: 'To the site',
    login: {
      metaTitleAcademy: 'Sign in · Deenly Academy',
      metaDescAcademy: 'Sign in and keep learning at Deenly Academy.',
      metaTitle: 'Sign in · Deenly',
      metaDesc: 'Sign in to the Deenly panel.',
      academy: {
        title: 'Welcome back.',
        accent: 'Pick up where you left off.',
        lead: 'Your topics, sources and reading are waiting for you.',
        cardTitle: 'Sign in to the Academy',
      },
      panel: {
        title: 'Welcome back.',
        accent: 'Edit. Publish. Follow.',
        lead: 'Deenly’s library, lectures, feed and analytics, all in one place.',
        cardTitle: 'Sign in to the panel',
      },
      locked: 'Too many wrong attempts. For security, signing in is paused. Try again in {time}.',
      errors: {
        credentials: 'That email or password isn’t right.',
        invalid: 'Enter a valid email address and password.',
        network: 'No connection to the server. Check your internet and try again.',
        server: 'Signing in isn’t working right now. Try again in a minute.',
      },
      notices: {
        reset: 'Your password has been changed. Sign in with the new one.',
        expired: 'Your session has expired. Sign in again.',
      },
      noAccount: 'No account yet?',
      createFree: 'Create one for free',
      teamOnly: 'Only team members have access. An administrator opens the account.',
      forgot: 'Forgot your password?',
      retryIn: 'Try again in {time}',
      submit: 'Sign in',
    },
    forgot: {
      metaTitle: 'Forgotten password · Deenly',
      metaDesc: 'A link for a new password, sent to your email.',
      invalidEmail: 'Enter a valid email address.',
      title: 'Forgot your password?',
      accent: 'A new one in a minute.',
      lead: 'Enter your account’s email and we’ll send you a link for a new password. The link is valid for 60 minutes.',
      cardSent: 'Check your email',
      cardLink: 'Link for a new password',
      sentBody: 'If an account with the address {email} exists, we’ve just sent a link for a new password. The link is valid for 60 minutes and works only once.',
      sentHint: 'Don’t see it? Check your spam too, or ask for a new one in a minute.',
      resend: 'Send again',
      backToLogin: 'Back to sign-in',
      send: 'Send link',
      remembered: 'I remember it now, back to sign-in',
    },
    reset: {
      metaTitle: 'New password · Deenly',
      metaDesc: 'Set a new password for Deenly.',
      title: 'New password.',
      accent: 'One step.',
      lead: 'After the change, every device you’re signed in on will be signed out.',
      cardBroken: 'The link isn’t complete',
      cardSet: 'Set a new password',
      hintBroken: 'Open the whole link from the email again, or ask for a new one.',
      hintAccount: 'For the account {email}',
      requestLink: 'Ask for a new link',
      newPassword: 'New password',
      repeat: 'Repeat the new password',
      mismatch: 'The passwords don’t match.',
      submit: 'Save new password',
    },
  },
  signup: {
    metaTitle: 'New account · Deenly Academy',
    metaDesc: 'A free account for Deenly Academy: your place for studying Islam.',
    title: 'Your place',
    accent: 'for studying Islam.',
    lead: 'Ayat, hadiths and notes on one map, your khatma and the books you’re reading, your university deadlines. Free.',
    cardTitle: 'New account',
    bullet1: 'A map of knowledge: ayat, hadiths, tafsir and notes in one place',
    bullet2: 'Evidence from the Quran and hadith, found by meaning',
    bullet3: 'Your khatma, books and deadlines, in front of you every day',
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
    firstName: 'First name',
    lastName: 'Last name',
    enterFirstName: 'Enter your first name.',
    enterLastName: 'Enter your last name.',
    repeatPassword: 'Repeat the password',
    mismatch: 'The passwords don’t match.',
    accept: 'I accept the {policy}.',
    policy: 'privacy policy',
    confirmTerms: 'Confirm that you accept the privacy policy.',
    submit: 'Create account',
  },
  layout: {
    closeMenu: 'Close menu',
    today: 'Today',
    spaces: 'Spaces',
    newSpace: 'New space',
    spacesFailed: 'The spaces didn’t load.',
    logout: 'Sign out',
    dialogSubtitle: 'A university subject or a personal goal: it holds your topics, tasks and reading.',
    subject: 'Subject',
    goal: 'Goal',
    placeholderGoal: 'e.g. Ramadan 1448',
    placeholderSubject: 'e.g. Usul al-fiqh III',
    create: 'Create space',
    ideas: {
      usul: 'Usul al-fiqh',
      tafsir: 'Tafsir',
      hadith: 'Hadith',
      arabic: 'Arabic',
      ramadan: 'Ramadan',
      khatma: 'Khatma',
      hifz: 'Hifz',
      exam: 'Exam',
    },
  },
  today: {
    metaTitle: 'Today · Study room · Deenly Academy',
    metaDesc: 'Your tasks, reading and topics.',
    morning: 'Good morning',
    day: 'Good afternoon',
    evening: 'Good evening',
    promptFiqh: 'The question you’re researching (e.g. “Is interest haram?”)',
    failed: 'We couldn’t load your Study room.',
    retry: 'Try again',
    weekTasks: 'This week’s tasks',
    allTasks: 'All tasks',
    noTasks: 'No tasks due in the next seven days.',
    doneAria: 'Done: {title}',
    inProgress: 'In progress',
    reading: 'Reading',
    planTitle: 'Set a reading plan',
    planBody: 'A khatma by the end of Ramadan, or a book for an exam: you’ll get a daily measure.',
    addReading: 'Add reading',
    continue: 'Pick up where you left off',
    firstTopic: 'Start your first topic',
    streak: 'Reading streak',
    days: 'day | days',
    weekAria: 'This week: {n} page | This week: {n} pages',
    weekPages: '{n} page this week | {n} pages this week',
    saveTip: 'You can also save an ayah while reading the Quran: the “Save” button under every ayah.',
  },
  collection: {
    metaTitle: 'Collection · Study room · Deenly Academy',
    metaDesc: 'Your ayat, hadiths, quotes and notes.',
    subtitle: 'Everything you save, once, for as many topics as you like.',
    newCard: 'New card',
    noResults: 'Nothing for this search.',
    empty: 'Your Collection is empty.',
    emptyBody: 'Save your first ayah, hadith or quote from a book. Every card carries its source, so you can cite it later.',
  },
  space: {
    fallback: 'Space',
    namePrompt: 'Space name',
    confirmDelete: 'Delete the space “{title}” with all its topics, tasks and reading? Cards stay in your Collection.',
    confirmDeleteTask: 'Delete this task?',
    deleteSpace: 'Delete space',
    navAria: 'Space',
    topics: 'Topics',
    tasks: 'Tasks',
    reading: 'Reading',
    newTopic: 'New topic',
    taskPlaceholder: 'New task, e.g. “Usul exam”',
    deadline: 'Due date',
    moveLeft: 'Move left: {title}',
    moveRight: 'Move right: {title}',
    khatmaPlan: 'Khatma plan',
    book: 'Book',
    readingEmpty: 'Add a khatma or a book you’re reading. Set an end date and you’ll get a daily measure.',
    fiqhLabel: 'The question you’re researching',
    topicName: 'Topic name',
    placeholderFiqh: 'e.g. Is interest haram?',
    placeholderTafsir: 'e.g. Ayat al-Kursi (2:255)',
    placeholderHadith: 'e.g. The hadith on intentions',
    previewFrames: 'The map starts with these frames',
    previewEmpty: 'Empty map',
    openMap: 'Open the map',
    task: 'Task',
    status: 'Status',
    topic: 'Topic',
    noTopic: 'No topic',
    notes: 'Notes',
    openTopic: 'Open the topic',
    bookPlaceholder: 'e.g. Ihya Ulum al-Din, vol. 1',
    khatma: 'Khatma',
    author: 'Author',
    pageCount: 'Number of pages',
    khatmaInfo: 'A khatma counts the 604 pages of the Medina mushaf; you’ll also see which juz you’re in.',
    finishBy: 'I want to finish by',
    optional: '(optional)',
    finishHint: 'With a date you get a daily measure: how many pages a day to finish on time.',
  },
  reading: {
    confirmDelete: 'Delete “{title}”?',
    khatmaJuz: 'Khatma · juz {juz}',
    until: 'until {date}',
    finished: 'Finished. May it be blessed!',
    measureMet: 'Today’s measure is met ({n} p.).',
    todayOf: 'Today: {read} of {target} page. | Today: {read} of {target} pages.',
    readToday: 'Read today: {n} p.',
    reachedPage: 'I’ve reached page',
    pagePlaceholder: 'Page (now {n})',
    plusPages: '+{n} p.',
  },
  picker: {
    title: 'From your Collection',
    subtitle: 'Click a card to put it on the map.',
    empty: 'No cards here. Add a source directly to the map.',
    onMap: 'On the map',
  },
  save: {
    label: 'Save to the Study room',
    saved: 'Saved to the Collection',
  },
  form: {
    confirmDelete: 'Delete this card from your Collection? It will also disappear from every topic it’s on.',
    editTitle: 'Edit card',
    addTitle: 'Add a source',
    intoFrame: 'Into the frame “{frame}”',
    toMapAndCollection: 'To the map, and to your Collection',
    toCollection: 'To your Collection',
    kindAria: 'Type of source',
    findSurah: 'Find a surah',
    surahPlaceholder: 'Surah: name or number',
    surahs: 'Surahs',
    ayahCount: '{n} ayah | {n} ayat',
    noSurah: 'No such surah.',
    surah: 'Surah',
    perCard: 'at most 20 per card',
    from: 'From',
    to: 'To',
    loadingAyat: 'Loading ayat…',
    searchHadiths: 'Search hadiths',
    hadithPlaceholder: 'Search Deenly’s collection: intention, riba…',
    hadithNote: 'For now the collection is mostly in English. Can’t find a hadith? {link}.',
    hadithManual: 'Enter it with its source',
    searching: 'Searching…',
    english: 'English',
    noResults: 'No results.',
    minLetters: 'Type at least three letters.',
    backToSearch: '← Back to search',
    hadithText: 'Text of the hadith…',
    scholarText: 'A quote or summary of what the scholar said…',
    noteText: 'Your note…',
    hadithSource: 'Source: collection and number',
    scholarSource: 'Work and author',
    hadithSourcePlaceholder: 'e.g. Muslim, 1598',
    scholarSourcePlaceholder: 'e.g. Ibn Qudamah, Al-Mughni',
    page: 'Page',
    titleOptional: 'Title (optional)',
    addNote: 'Add your own note to the source',
    myNote: 'My note',
    notePlaceholder: 'What this is evidence for, what matters to you…',
    addToMap: 'Add to the map',
    saveToCollection: 'Save to the Collection',
    deleteFromCollection: 'Delete from the Collection',
  },
  node: {
    notePlaceholder: 'Write…',
    noteEmpty: 'Double-click to write',
    duplicate: 'Duplicate',
    textPlaceholder: 'Title…',
    textEmpty: 'Double-click for text',
    tidyLabel: 'Arrange cards',
    tidy: 'Arrange',
    deleteFrame: 'Delete frame',
    frame: 'Frame',
    addInto: 'Add to: {title}',
    open: 'Open',
    removeFromMap: 'Take off the map',
  },
  quick: {
    addToMap: 'Add to the map',
    placeholder: 'Ayah, root or topic…',
    hint: 'E.g. 2:255 · al-baqarah 255-257 · yasin 1 · رحم · patience',
    rootTitle: 'Root {root}',
    rootText: 'The words from this root and how many times they occur in the Quran.',
    surah: 'Surah {n}',
    evidence: 'Find evidence',
    evidenceHint: 'Put the 3 closest ayat and 3 hadiths on the map, each in its own frame.',
    noResults: 'Nothing for this. Try a reference (2:255) or another word.',
    enter: 'Enter: to the map',
  },
  explorer: {
    title: 'Explore',
    tabs: {
      words: 'Words',
      tafsir: 'Tafsir',
      translations: 'Translations',
      related: 'Ayat',
      hadiths: 'Hadiths',
      sharh: 'Sharh',
      lessons: 'Lessons',
      ayat: 'Ayat',
    },
    surah: 'Surah {n}',
    tafsirName: 'Tafsir Al-Mukhtasar',
    tafsirTitle: 'Tafsir Al-Mukhtasar · {ref}',
    tafsirSource: 'Tafsir Al-Mukhtasar, {ref}',
    translationTitle: 'Translation: {name}',
    translationSource: 'Quran, {ref}, translation: {name}',
    sharhTitle: 'Sharh: {title}',
    sharhSource: 'HadeethEnc.com, explanation of the hadith',
    lessonTitle: 'A lesson from the hadith',
    lessonsTitle: 'Lessons from the hadith',
    edge: {
      tafsir: 'tafsir',
      translation: 'translation',
      root: 'root',
      rootOf: 'root {root}',
      hadith: 'hadith',
      sharh: 'sharh',
      lesson: 'lesson',
      lessons: 'lessons',
      related: 'related ayah',
      ayah: 'ayah',
    },
    backToAyah: 'Back to the ayah',
    hadithFallback: 'Hadith',
    whatToExplore: 'What to explore',
    failed: 'It didn’t load. Try again.',
    wordsHint: 'Tap a word to see its root across the whole Quran.',
    noTafsir: 'There’s no tafsir for this ayah yet.',
    relatedHint: 'The ayat closest in meaning. Drag them onto the map.',
    noRelated: 'No related ayat for this ayah.',
    hadithsHint: 'The hadiths closest in meaning to this ayah. Drag them onto the map.',
    noHadiths: 'No hadiths for this ayah.',
    explanation: 'Explanation of the hadith',
    noExplanation: 'No explanation for this hadith.',
    allLessons: 'All lessons as one note',
    noLessons: 'No lessons for this hadith.',
    ayatHint: 'The ayat closest in meaning to this hadith.',
    noAyat: 'No related ayat.',
    rootOnMap: 'Root to the map',
    rootStats: '{times} in {ayahs}, in {surahs}',
    rootTimes: '{n} time | {n} times',
    rootAyahs: '{n} ayah | {n} ayat',
    rootSurahs: '{n} surah | {n} surahs',
    previous: 'Previous',
    next: 'Next',
  },
  topic: {
    fallback: 'Topic',
    newFrame: 'New frame',
    added: 'Added to the map and to your Collection.',
    removedCount: 'Deleted: {n}.',
    cardRemoved: 'Card taken off the map (it stays in your Collection).',
    removed: 'Deleted.',
    confirmDelete: 'Delete this topic and its map? Cards stay in your Collection.',
    restOfMap: 'Elsewhere on the map',
    copied: 'Copied. Paste it into Word or Google Docs.',
    tools: {
      search: 'Find and add',
      note: 'Note',
      text: 'Text',
      frame: 'Frame',
      ayah: 'Ayah',
      hadith: 'Hadith',
      quote: 'Scholar’s quote',
    },
    addHere: 'Add here',
    edgePlaceholder: 'e.g. proves, explains',
    deleteArrow: 'Delete arrow',
    emptyTitle: 'Your map is ready.',
    tipSearch: 'Press / and type an ayah (2:255, al-baqarah 255), a root or a topic.',
    tipExplore: 'Select an ayah on the map: its words, tafsir, translations and related ayat open.',
    tipPlus: 'Click ＋ in a frame to add an ayah, hadith or quote right there.',
    tipDouble: 'Double-click anywhere on the map for a note, text or a new frame.',
    tipArrow: 'Drag from the dot on a card’s edge to another card: you get an arrow.',
    copyAsText: 'Copy as text',
    emptyDoc: 'The map is still empty.',
    back: 'Back',
    document: 'Document',
    presentTitle: 'Present the frames as slides',
    present: 'Present',
    deleteTopic: 'Delete topic',
    toolsAria: 'Tools',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    fitAll: 'Show everything',
    zoomHint: 'Double-click: add · Shift + drag: select several · Delete: delete',
    presentationAria: 'Presentation',
    prevFrame: 'Previous frame',
    nextFrame: 'Next frame',
    finish: 'Finish',
    undo: 'Undo',
    myNote: 'My note',
    wordByWord: 'Word by word',
    tafsir: 'Tafsir',
    link: 'Link',
  },
};
